"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropareaVisibility = void 0;
/* ========================================================================
    Module: Drop area visibility
 ========================================================================== */
/**
 * ファイルアップロードのドロップエリアをモバイルデバイスの時のみ非表示にする
 *
 * @returns {void}
 */
const dropareaVisibility = () => {
    const dropAreaElements = document.querySelectorAll(".js-upload-file-droparea");
    if (dropAreaElements.length === 0) {
        return;
    }
    if (navigator.userAgent.match(/iPhone|iPad|Android.+Mobile/)) {
        dropAreaElements.forEach((element) => {
            element.style.display = "none";
        });
    }
};
exports.dropareaVisibility = dropareaVisibility;
